import { HttpClient } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { Credentials } from '@shared/interfaces/credentials';
import { Observable } from 'rxjs';

@Injectable({ providedIn: 'root' })
export class AuthService {
  private http = inject(HttpClient);

  initiateLogin(email: string): Observable<void> {
    return this.http.post<void>('/api/admin/authenticate/init', { email });
  }

  finalizeLogin(value: Credentials): Observable<void> {
    return this.http.post<void>('/api/admin/authenticate/finalize', value);
  }

  authenticated(): Observable<boolean> {
    return this.http.get<boolean>('/api/authenticate');
  }

  logout(): Observable<void> {
    return this.http.delete<void>('/api/logout');
  }
}
